import React, { useEffect } from 'react';
import './HomeApp.css';
import AsideLeft from './AppAdminComponents/AsideLeft';
import ContentAdminDashboard from './AppAdminComponents/ContentDashboard';
import NavBarNotificationBar from './AppAdminComponents/NavBarNotificationBar';
import Swal from 'sweetalert2';
import { getStatus } from '../helpers/user.helper';
import { getuser } from '../helpers/user.helper';
import ContentUserDashboard from './AppAdminComponents/ContentUserDashboard';
import ContentCustomerDashboard from './AppAdminComponents/ContentCustomerDashboard';
import Footer from '../components/Footer';

export default function HomeApp() {
    useEffect(() => {
        if (getStatus() === 'EA') {
            Swal.fire({
                closeOnClickOutside: false,
                allowOutsideClick: false,
                icon: 'error',
                title: 'Oops...',
                text: 'Seu usuário ainda não foi liberado para venda!',
                footer: '<a href="/contato">Entre em contato em caso de dúvida.</a>'
            })
        }
    }, [])

    return (
        <>
            <div className="wrapper">
                {/* Navbar */}
                <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                    <NavBarNotificationBar />

                </nav>
                <AsideLeft />


                {
                    getuser().type === "A" ?
                        <ContentAdminDashboard />
                        :
                        getuser().type === "C" ?
                            <ContentCustomerDashboard />
                            :
                            <ContentUserDashboard />
                }
                <Footer />

            </div>

        </>
    )
}
